
















































































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { State } from 'vuex-class';
import {
  AuditDetail,
  AuditStatus,
} from '@/store/modules/audits/types/audits.types';
import { ProjectDetailPayload } from '@/store/modules/projects/types/projects.types';
import { UserRoleInAudit } from '../../../store/modules/projects/types/projects.types';

@Component
export default class AddProjectCriteriaIntoAuditCycle extends Vue {
  @Prop() public selectedAuditCycleIds!: number[];

  public isCollapseOpen: boolean = false;
  public selectedAuditCycles: number[] = [];
  public checkedAll: boolean = false;

  @State((state) => state.projects.projectDetail)
  public projectDetail!: ProjectDetailPayload;

  get projectIdFromParam() {
    return +this.$route.params.projectId;
  }

  /** Filter audit list based on user role */
  get auditList(): AuditDetail[] {
    return this.projectDetail && this.projectDetail.audits
      ? this.projectDetail.audits.filter(
          (audit) =>
            audit.userRoleInAudit === UserRoleInAudit.isOwner ||
            audit.userRoleInAudit === UserRoleInAudit.isProjectCoOrdinator,
        )
      : [];
  }

  get upcomingAuditIds(): number[] {
    /** criteria can be added only in active upcoming audit cycles */
    return this.auditList
      .filter(
        (audit) =>
          audit.status === AuditStatus.ACTIVE &&
          audit.startedAt === null &&
          audit.endedAt === null,
      )
      .map((audit) => audit.id);
  }

  get isActiveCycles(): boolean {
    return this.auditList.some((audit) => audit.status === AuditStatus.ACTIVE);
  }

  mounted() {
    this.selectedAuditCycles = this.selectedAuditCycleIds;
  }

  isAuditCycleCommencedOrEnded(audit: AuditDetail): boolean {
    return (
      audit.status === AuditStatus.ARCHIVED ||
      audit.startedAt !== null ||
      audit.endedAt !== null
    );
  }

  tooltipInfoMsg(audit: AuditDetail): string {
    if (audit.startedAt !== null) {
      return 'This cycle has already started';
    } else if (audit.endedAt !== null) {
      return 'This cycle has already ended';
    } else if (audit.status === AuditStatus.ARCHIVED) {
      return 'This cycle has Archived';
    } else {
      return '';
    }
  }

  @Watch('selectedAuditCycles', { deep: true })
  onSelectedAuditCycles() {
    if (
      this.selectedAuditCycles.length &&
      this.selectedAuditCycles.length === this.upcomingAuditIds.length
    ) {
      this.checkedAll = true;
    } else {
      this.checkedAll = false;
    }

    this.$emit('selectedAuditCycles', this.selectedAuditCycles);
  }

  @Watch('checkedAll')
  onCheckAll() {
    if (this.checkedAll) {
      this.selectedAuditCycles = [...this.upcomingAuditIds];
    } else if (
      !this.checkedAll &&
      this.selectedAuditCycles.length === this.upcomingAuditIds.length
    ) {
      this.selectedAuditCycles = [];
    }

    this.$emit('selectedAuditCycles', this.selectedAuditCycles);
  }
}
